import { EventChannel } from '@cian/chats-api/lib/browser/event_channel';

import { IAnswerEvent } from '../actions/wsAnswer/types';
import { IMessageEvent } from '../actions/wsMessage/types';
import { ISessionEvent } from '../actions/wsSession';
import { IStatusEvent } from '../actions/wsStatus/types';

type TSocketState = {
  eventChannel: EventChannel;
  clientEvents: TClientEventsState;
};

/**
 * Интерфейс хранилища пользовательских событий.
 * В виде {key} - uid события, {value} - объект события
 */
type TClientEventsState = Map<string, IMessageEvent | ISessionEvent | IAnswerEvent | IStatusEvent>;

export { EventChannel };
export type { TSocketState };

export enum ESocketCloseCustomCode {
  /** Текущая вкладка браузера стала неактивной/невидимой */
  CurrentBrowserTabBecomeInactive = 4000,
  /** Пользователь разлогинился */
  UserLogout = 4001,
}
